import styled from 'styled-components'

export const Wrapper = styled.div<any>`
  position: sticky;
  top: 0;
  z-index: 9;
  background: ${props => props.theme.palette.general.light};

  > .wrapper {
    padding: 10px;

    > button {
      background-color: ${props => props.isSofiaAndGrace ? props.theme.palette.primary.beta : props.theme.palette.primary.alphaDark};
    }

    .menu-icon {
      padding: 10px 6px 8px;
      appearance: none;
      border: none;

      &:active,
      &:focus {
        outline: none;
      }

      &.menu-open {
        box-shadow: ${props => props.theme.palette.general.boxShadow};
      }
    }
  }
`

export const Logo = styled.div`
  margin: 0 auto 0 10px;

  > a {
    display: block;
    height: 40px;
  }

  svg {
    max-width: 140px;
  }

  img {
    max-height: 100%;
  }
`
